import React from "react";
import { motion } from "framer-motion";
import { ArrowDown } from "@phosphor-icons/react";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-start overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1549505415-e16dbd446231?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHw0fHxmaXRuZXNzJTIwbW9kZWwlMjBwb3J0cmFpdCUyMGd5bXxlbnwwfHx8fDE3NzU3NTMxMDl8MA&ixlib=rb-4.1.0&q=85"
          alt="Fitness influencer"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 px-6 md:px-12 lg:px-24 max-w-7xl mx-auto w-full pt-32 pb-20">
        <motion.div
          initial={{ opacity: 0, x: -60 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <p
            data-testid="hero-overline"
            className="text-xs sm:text-sm uppercase tracking-[0.25em] font-bold text-[#FF3B30] mb-6"
          >
            Fitness & Wellness Influencer
          </p>

          <h1
            data-testid="hero-heading"
            className="font-['Barlow_Condensed'] text-5xl sm:text-6xl lg:text-8xl font-black uppercase tracking-tighter leading-[0.9] text-white max-w-4xl"
          >
            Elevate Your
            <br />
            Brand With
            <br />
            <span className="text-[#FF3B30]">Authentic</span> Reach
          </h1>

          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4, duration: 0.6 }}
            data-testid="hero-subtitle"
            className="text-base sm:text-lg text-white/60 max-w-lg mt-8 leading-relaxed"
          >
            Partnering with premium fitness and wellness brands to create
            high-converting content that moves audiences and drives results.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6, duration: 0.6 }}
            className="flex flex-wrap gap-4 mt-10"
          >
            <a
              href="#contact"
              data-testid="hero-cta-button"
              className="bg-[#FF3B30] text-white px-8 py-4 font-bold uppercase tracking-wider text-sm hover:bg-[#FF5C54] transition-colors inline-flex items-center gap-2"
            >
              Start a Collaboration
            </a>
            <a
              href="#portfolio"
              data-testid="hero-secondary-cta"
              className="bg-transparent text-white border border-white/20 px-8 py-4 font-bold uppercase tracking-wider text-sm hover:bg-white hover:text-black transition-all inline-flex items-center gap-2"
            >
              View Portfolio
            </a>
          </motion.div>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 1.2 }}
          className="absolute bottom-8 left-1/2 -translate-x-1/2"
        >
          <motion.div
            animate={{ y: [0, 12, 0] }}
            transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
          >
            <ArrowDown size={24} className="text-white/40" />
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
